import { render, staticRenderFns } from "./editar-acesso.vue?vue&type=template&id=a13c401c&"
import script from "./editar-acesso.vue?vue&type=script&lang=ts&"
export * from "./editar-acesso.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports